import { useState, useEffect, useCallback } from 'react';
import api from '../config/api';

export const useUserPreferences = () => {
  const [preferences, setPreferences] = useState({
    preferredCurrency: 'USD',
    emailNotifications: true,
    pushNotifications: true,
    darkMode: false,
    locationSharing: false,
    vacationGoal: null,
    destinationType: null,
    tripDuration: null,
    budgetRange: null,
    travelCompanions: null,
    accommodationType: null,
    priority: null,
    travelDistance: null,
    planningStyle: null,
    preferredSeason: 'no_preference',
    reminderEnabled: true,
    reminderTimeAdvance: 1440,
    reminderTimezone: 'America/New_York'
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPreferences = useCallback(async () => {
    try {
      setError(null);
      const response = await api.get('/preferences');
      setPreferences(response.data);
    } catch (err) {
      console.error('Error fetching preferences:', err);
      setError('Failed to fetch preferences');
      // Keep default preferences on error
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPreferences();
  }, [fetchPreferences]);

  return {
    preferences,
    loading,
    error,
    refetch: fetchPreferences
  };
};
